<template>
<div class="chapter">
<div class="inner_page">
<div class="pseudo_margin_1"></div>
<div class="section" id="section007">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<p class="poem_title1" id="ch1"><a id="page_viii"></a><a id="page_1"></a>1.</p>
<div class="pseudo_margin_2"></div>
<p class="negative_indent_1">How do you picture the shape of a year in your head</p>
<p class="negative_indent_1">Is a question my grandmother often asked.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">The jog ends at the point where we watch the sun disappear.</p>
<p class="negative_indent_1">We drag sticks in the sand to spell out our names.</p>
<p class="negative_indent_1">To myself I write: Happy Birthday.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">The few trees before the beach in silhouette.</p>
<p class="negative_indent_1">The sky is red, the boats in the small harbor, docked.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">On the Rappahannock my grandparents moved to retire.</p>
<p class="negative_indent_1">As they aged, my mother rented herself this house.</p>
<p class="negative_indent_1">Because the land is the same level as the water</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">The house sits high up on stilts. At night, from bed,</p>
<p class="negative_indent_1">The stars through the windows burn a circuit of lights.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">It all depends on where you start. A year is a circle,</p>
<p class="negative_indent_1">If not a point around which experience spirals.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_1">Because our mother is gone, we do not need the house.</p>
<p class="negative_indent_1">We tell ourselves this. Soon we will clean out inside.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter001.vue?28cf6a63